/* eslint-disable */
import _ from 'underscore';
import * as _SharedEditorView from '@bingads-webui-campaign-legacy/adextension-shared/view/extension-editor';
var schema = window.globalLegacySchema.get('CalloutAdExtension');
var SharedEditorView = _SharedEditorView.default;
var EditorView = SharedEditorView.extend({
  initialize: function (options) {
    options = _.extend(options || ({}), {
      schema: schema,
      fields: [{
        property: 'Text',
        showHint: true
      }]
    });
    SharedEditorView.prototype.initialize.call(this, options);
  }
});
export default EditorView;

